import { useLookupOptions } from "../../hooks/useLookupOptions";
import { ReadOnlyField } from "./ReadOnlyField";
import { ReadOnlyEntityLookupFieldProps } from "./ReadOnlyEntityLookupField.types";

/** A read-only lookup to another entity, named from that entity's records. */
export function ReadOnlyEntityLookupField({
  lookupEntity,
  value,
  ...rest
}: ReadOnlyEntityLookupFieldProps) {
  const { options } = useLookupOptions(lookupEntity);
  const picked = options.find((option) => String(option.Key) === String(value));

  return <ReadOnlyField {...rest} text={picked?.Value ?? ""} />;
}
